export function Avatar({ src, name, size = 44 }) {
  const initial = (name || '?').trim().charAt(0).toUpperCase() || '?'
  if (src) {
    return (
      <img
        src={src}
        alt={name || ''}
        style={{ width: size, height: size }}
        className='rounded-full object-cover ring-2 ring-warm_border dark:ring-dk-border shadow-sm shrink-0'
      />
    )
  }
  return (
    <div
      style={{ width: size, height: size }}
      className='rounded-full bg-coral/15 text-coral_deep font-display font-bold flex items-center justify-center ring-2 ring-warm_border dark:ring-dk-border shrink-0'
    >
      {initial}
    </div>
  )
}

export function formatCreated(created) {
  if (!created) return null
  const d = new Date(created)
  if (isNaN(d.getTime())) return null
  const days = Math.floor((Date.now() - d.getTime()) / 86400000)
  return { date: d.toLocaleDateString('es-AR'), days, recent: days >= 0 && days < 30 }
}

export function CreatedLine({ user }) {
  const info = formatCreated(user && (user.created || user.created_at))
  if (!info) return null
  return (
    <span className={`block text-xs truncate ${info.recent ? 'text-coral_deep font-medium' : 'text-warm_gray dark:text-gray-400'}`}>
      Cuenta creada {info.date}{info.recent ? ` · hace ${info.days}d` : ''}
    </span>
  )
}

export function TripsLine({ user }) {
  if (!user || user.trips_count == null) return null
  const first = user.first_trip_date ? new Date(user.first_trip_date) : null
  const firstLabel = first && !isNaN(first.getTime()) ? first.toLocaleDateString('es-AR') : null
  return (
    <span className='block text-xs text-warm_gray dark:text-gray-400 truncate'>
      {user.trips_count} {user.trips_count === 1 ? 'viaje' : 'viajes'}
      {firstLabel ? ` · primero ${firstLabel}` : ''}
    </span>
  )
}

export function openUser(userId) {
  window.open(
    `${window.location.origin}?navigation=UserSearch&user_id=${encodeURIComponent(userId)}`,
    '_blank'
  )
}
